<template>
  <v-app class="app">
      <router-view>
      </router-view>
  </v-app>
</template>

<script>

export default {
  name: 'Main',
  data: () => ({
    //
  })
}
</script>

<style lang="css">
* {
  text-transform: none;
}

#app {
  background-color: #EAEDED;
}
</style>
